import React from 'react';

import CommonNode from '../../../../components/node/common-node';
import { NodeProvider } from '../../../../context/node-context';
import { getNodeName } from '../../../../utils/getNodeName';
import BatchTaskForm from './forms/batch-task-form';
import { batchTaskValidationSchema } from './schema.js';

export default function DataOperationBatchNode({ data, id, type }) {
  const nodeName = getNodeName(data?.name, 'Data Operation Batch Task');

  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: nodeName,
        altText: 'Data Operation Batch Task',
        defaultLabel: 'Data Operation Batch Task',
      }}
    >
      <CommonNode FormComponent={BatchTaskForm} schemaResolver={batchTaskValidationSchema} />
    </NodeProvider>
  );
}
